"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _checkbox = _interopRequireDefault(require("./checkbox"));

var _icon = _interopRequireDefault(require("./icon"));

var _checkbox_states = _interopRequireDefault(require("./utils/checkbox_states"));

require("../css/checkbox_group.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var itemsPropType = _propTypes.default.arrayOf(_propTypes.default.shape({
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  id: _propTypes.default.number.isRequired,
  name: _propTypes.default.string.isRequired,
  totalItems: _propTypes.default.number,
  value: _propTypes.default.node.isRequired,
  isExpanded: _propTypes.default.bool
}));

var Label = function Label(_ref) {
  var name = _ref.name,
      totalItems = _ref.totalItems;
  return _react.default.createElement("span", {
    className: "vn-checkbox_group__item-label"
  }, _react.default.createElement("span", {
    className: "vn-checkbox_group__item-label-text"
  }, name, totalItems != null && _react.default.createElement("span", {
    className: "vn-checkbox_group__item-label-text-total vn-checkbox_group__item-label-text-total".concat(totalItems <= 0 ? '--disabled' : '')
  }, "(".concat(totalItems, ")"))));
};

Label.propTypes = {
  name: _propTypes.default.node.isRequired,
  totalItems: _propTypes.default.number
};
Label.defaultProps = {
  totalItems: null
};

var CheckboxGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CheckboxGroup, _React$Component);

  function CheckboxGroup(props) {
    var _this;

    _classCallCheck(this, CheckboxGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxGroup).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (changed) {
      var items = _this.state.items.map(function (item) {
        return _this.initializeItem(item, changed.target.id);
      });

      if (_this.props.onChange) {
        _this.props.onChange(items);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChangeCG", function (children) {
      var father = _this.state.items;
      father.forEach(function (item, index) {
        if (item.items != null) {
          if (item.items[0].id === children[0].id) {
            father[index].items = children;
            father[index].checked = undefined;
          }
        }
      });

      _this.props.onChange(father);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (clicked) {
      var father = _this.state.items;
      father.forEach(function (item, index) {
        if (String("arrow".concat(item.id)) === clicked.target.id) {
          var newItem = item;
          newItem.isExpanded = !item.isExpanded;
          father[index] = newItem;

          _this.setState({
            items: father
          });
        }
      });
    });

    _this.state = {
      items: props.items
    };
    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        items: nextProps.items
      });
    }
  }, {
    key: "initializeItem",
    value: function initializeItem(item, id) {
      var _this2 = this;

      if (String(item.id) === id) {
        var _newItem = item;

        if (_newItem.checked === _checkbox_states.default.checked || _newItem.checked === _checkbox_states.default.indeterminated) {
          _newItem.checked = _checkbox_states.default.unchecked;
        } else {
          _newItem.checked = _checkbox_states.default.checked;
        }

        return _newItem;
      }

      if (item.items == null) {
        return item;
      }

      var newItem = item;
      newItem.items = item.items.map(function (child) {
        var newChild = child;
        newChild = _this2.initializeItem(newChild);
        return newChild;
      });
      newItem.checked = undefined;
      return newItem;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement("div", null, _react.default.createElement("ul", null, this.state.items.map(function (item) {
        var disabled = false;

        if (item.totalItems <= 0) {
          disabled = true;

          if (_this3.props.hideEmpty === true) {
            return null;
          }
        }

        var arrowClasses = (0, _classnames.default)({
          'vn-checkbox_group__item-arrow-icon': true,
          'vn-checkbox_group__item-arrow-icon--expanded': item.isExpanded
        });
        return _react.default.createElement("li", {
          className: "vn-checkbox_group__item-li",
          key: item.id
        }, _react.default.createElement("div", {
          className: "vn-checkbox_group__item",
          role: "group",
          "aria-label": item.name
        }, item.items != null ? _react.default.createElement("div", {
          role: "presentation",
          style: {
            display: 'inline-block'
          },
          id: "arrow".concat(String(item.id)),
          onClick: _this3.handleClick
        }, _react.default.createElement(_icon.default, {
          style: {
            'pointer-events': 'none'
          },
          className: arrowClasses,
          name: "chevron",
          size: 24
        })) : _react.default.createElement("div", {
          style: {
            display: 'inline',
            marginRight: '15px'
          }
        }), _react.default.createElement("div", {
          className: "vn-checkbox_group__item-div"
        }, _react.default.createElement(_checkbox.default, {
          id: String(item.id),
          checked: _checkbox_states.default[item.checked],
          label: _react.default.createElement(Label, item),
          name: item.name,
          onChange: _this3.handleChange,
          disabled: disabled
        }))), item.items != null && item.isExpanded && _react.default.createElement("div", {
          style: {
            marginLeft: '20px'
          }
        }, _react.default.createElement(CheckboxGroup, {
          items: item.items,
          onChange: _this3.handleChangeCG
        })));
      }, this)));
    }
  }]);

  return CheckboxGroup;
}(_react.default.Component);

CheckboxGroup.propTypes = {
  hideEmpty: _propTypes.default.bool,
  items: itemsPropType.isRequired,
  onChange: _propTypes.default.func.isRequired
};
CheckboxGroup.defaultProps = {
  hideEmpty: false
};
CheckboxGroup.displayName = 'CheckboxGroup';
var _default = CheckboxGroup;
exports.default = _default;